import { createSlice } from '@reduxjs/toolkit';
import sum from 'lodash/sum';
import uniqBy from 'lodash/uniqBy';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  allConsults: [],
  myConsults: [],
  pendingActions: [],
  prescriptions: [],
  prescription: null,
  securityTokenValid: true,
  currentStatus: 'available',
};

const slice = createSlice({
  name: 'consult',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PRESCRIPTION
    getPrescriptionSuccess(state, action) {
      state.isLoading = false;
      state.prescription = action.payload;
    },

    // VALIDATE SECURITY TOKEN
    validateSecurityTokenSuccess(state, action) {
      console.log('security Token response', action.payload)
      state.isLoading = false;
      state.securityTokenValid = action.payload;
    },

    // GET PRODUCT
    updatePrescriptionSuccess(state, action) {
      state.isLoading = false;
      state.consultDetails = action.payload;
    },

    startConsult(state) {
      state.currentStatus = 'engaged';
    },

    endConsult(state) {
      state.currentStatus = 'available';
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startConsult,
  endConsult,
} = slice.actions;

// ----------------------------------------------------------------------

export function getPrescription() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/prescriptions/manage/get', {});
      dispatch(slice.actions.getConsultsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updatePrescription(consultId) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/prescriptions/manage/update', {
        consultId
      });
      dispatch(slice.actions.getConsultSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function validateSecurityToken(securityToken) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/prescriptions/manage/validate_token', {
        securityToken
      });
      dispatch(slice.actions.validateSecurityTokenSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function finalizePrescription(consultId) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/prescriptions/manage/finalize', {
        consultId
      });
      dispatch(slice.actions.getConsultSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
